import * as THREE from 'three';

/**
 * Uniform objects shared (by reference) between every lit material in the scene.
 * Systems write `.value` once per frame; all materials see the change.
 */
export const shared = {
  // atmosphere / lighting
  uSkyIrr: { value: null as THREE.Texture | null },
  uTransLUT: { value: null as THREE.Texture | null },
  uSunDir: { value: new THREE.Vector3(0, 1, 0) },
  uSunColorTOA: { value: new THREE.Vector3(Math.PI, Math.PI, Math.PI) },
  uGroundRadiusMM: { value: 6.36 },
  uAtmoRadiusMM: { value: 6.46 },
  uCloudShadow: { value: null as THREE.Texture | null },
  uCloudShadowXform: { value: new THREE.Vector4(0, 0, 1e-5, 0) },
  uCloudFar: { value: 1 },
  uWetness: { value: 0 },
  uSnowCover: { value: 0 },
  uLightning: { value: 0 },
  uCurvOrigin: { value: new THREE.Vector3() },
  uTime: { value: 0 },
  uWind: { value: new THREE.Vector4(1, 0, 0.3, 0) }, // xy dir, z strength, w gust phase
  uCamPos: { value: new THREE.Vector3() },
  // strata
  uStrata: { value: null as THREE.Texture | null },
  uStrataRange: { value: new THREE.Vector2(2000, 700) },
  // procedural detail noise (tileable RGBA)
  uNoise: { value: null as THREE.Texture | null },
  uDetailFade: { value: 1 },
  // near-terrain sky visibility (bound once terrain data is loaded)
  uTerrainVis: { value: null as THREE.Texture | null },
  uTerrainVisB: { value: new THREE.Vector4(0, 0, 1, 0) },
};

export type SharedUniforms = typeof shared;
